import React from 'react';

class DataText extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      content : this.props.defaultValue!==undefined?this.props.defaultValue:"",
    };
  }

  onSetTimeout() {
  }

  onInit (overlayConfig) {
  }


  onData (data,key) {
    if(key !== undefined) {
        if(key === this.props.stateName){
          this.setState({content: data.value});
        }
      // this.forceUpdate();
    }
  }

  componentDidMount() {
    this.props.display.registDataListener(this.props.stateName,this);

    if(this.props.readAlong !== undefined) {
      var readAlongs = this.props.readAlong.split("|");
      for (var r in readAlongs){
          this.props.display.registDataListener(readAlongs[r],this);
      }
    }

    this.props.display.sendMeStateInfo(this.props.stateName);
  }

  render() {
     return this.state.content;
  }
}
export default DataText;
